import capitalize from "lodash/capitalize";
import lowerCase from "lodash/lowerCase";

import SEOHelmet from "@/components/helpers/seo/SEOHelmet";
import PageContainer from "@/components/pages_flexible/PageContainer";
import AuthArticleSeries from "@/components/pieces/learn/article_series";
import { getUser } from "@/components/session/JwtTokenManager";

import SeoArticleSeries from "./SeoArticleSeries";

function ArticleSeries({ articleSeries, articlesData }) {
  const user = getUser();
  if (user) {
    return <AuthArticleSeries articleSeries={articleSeries} />;
  }
  return <SeoArticleSeries articleSeries={articleSeries} {...articlesData} />;
}

interface ArticleSeriesType {
  title: string;
  description?: string;
  urlSlug: string;
  canonicalDomain: string;
}

export default function ArticleSeriesPage({
  articleSeries = {} as ArticleSeriesType,
  articlesData,
}) {
  const { title, description, urlSlug, canonicalDomain } = articleSeries;
  return (
    <PageContainer maxWidth="100%" layout="learnArticle" contentType="roleplay">
      <SEOHelmet
        title={`${capitalize(canonicalDomain)} Learn: ${title}`}
        description={
          description ||
          "Use our tips, guides, and tools to grow your career. Written by career experts, coaches, and talent leaders."
        }
        canonicalPath={`/learn/series/${urlSlug}`}
        canonicalDomain={`https://${lowerCase(canonicalDomain)}.com`}
        image={
          IS_EXEC
            ? "https://placement-pub.s3.us-east-2.amazonaws.com/exec-learn-meta.jpg"
            : "https://placement-pub.s3.us-east-2.amazonaws.com/learn-meta.png"
        }
        bodyAttributes={{ class: "public-site" }}
      />
      <ArticleSeries
        articlesData={articlesData}
        articleSeries={articleSeries}
      />
    </PageContainer>
  );
}
